var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.post_title_editing,
        "before-close": _vm.cancelRename
      },
      on: {
        "update:visible": function($event) {
          _vm.post_title_editing = $event
        }
      }
    },
    [
      _c(
        "h5",
        {
          staticClass: "el-dialog__title",
          attrs: { slot: "title" },
          slot: "title"
        },
        [_vm._v("Rename Form")]
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "mt-4",
          attrs: { model: {}, "label-position": "top" },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.renameForm($event)
            }
          }
        },
        [
          _c(
            "el-form-item",
            { staticClass: "ff-form-item", attrs: { label: "Form Title" } },
            [
              _c("el-input", {
                staticClass: "renameForm",
                attrs: { name: "post_title", type: "text" },
                model: {
                  value: _vm.post.post_title,
                  callback: function($$v) {
                    _vm.$set(_vm.post, "post_title", $$v)
                  },
                  expression: "post.post_title"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticClass: "el-button--soft",
              attrs: { type: "info" },
              on: { click: _vm.cancelRename }
            },
            [_vm._v("Cancel")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.renameForm }
            },
            [
              _vm.loading
                ? _c("span", [_vm._v("Renaming Form")])
                : _c("span", [_vm._v("Rename")])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }